<template>
  <div id="app">
    <router-view/>
    <div v-if="runtimeError.visible" class="runtime-error-mask">
      <div class="runtime-error-card">
        <h2>页面加载失败</h2>
        <p v-if="runtimeError.id" class="runtime-error-id">错误编号：{{ runtimeError.id }}</p>
        <p>{{ runtimeError.message }}</p>
        <p v-if="runtimeError.detail" class="runtime-error-detail">{{ runtimeError.detail }}</p>
        <p v-if="runtimeError.healthMessage" class="runtime-error-health">{{ runtimeError.healthMessage }}</p>
        <div class="runtime-error-actions">
          <button @click="goHome">返回首页</button>
          <button @click="checkHealth">检查服务</button>
          <button @click="copyRuntimeLogs">复制日志</button>
          <button @click="reloadPage">重新加载</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import settings from "@/assets/js/settings";

export default {
  data() {
    return {
      runtimeError: {
        visible: false,
        id: '',
        message: '',
        detail: '',
        healthMessage: ''
      }
    }
  },
  mounted() {
    window.addEventListener('app-runtime-error', this.handleRuntimeError)
  },
  beforeDestroy() {
    window.removeEventListener('app-runtime-error', this.handleRuntimeError)
  },
  methods: {
    handleRuntimeError(event) {
      const detail = event.detail || {}
      this.runtimeError.visible = true
      this.runtimeError.id = detail.id || ''
      this.runtimeError.message = detail.message || '应用运行异常，请重新打开首页'
      this.runtimeError.detail = `${detail.source || 'unknown'} ${detail.info || ''}`.trim()
      this.runtimeError.healthMessage = ''
    },
    goHome() {
      window.location.href = settings.SITE_ORIGIN
    },
    reloadPage() {
      window.location.reload()
    },
    async checkHealth() {
      try {
        const response = await fetch(`${settings.SITE_ORIGIN}/api/v1/healthz/`, {cache: 'no-store'})
        this.runtimeError.healthMessage = response.ok ? '前端入口正常，可尝试重新打开首页。' : '健康检查失败，请联系管理员。'
      } catch (e) {
        this.runtimeError.healthMessage = '健康检查失败，请检查网络或服务状态。'
      }
    },
    async copyRuntimeLogs() {
      const logs = window.__SEAF_GET_RUNTIME_ERRORS__ ? window.__SEAF_GET_RUNTIME_ERRORS__() : []
      const text = JSON.stringify(logs, null, 2)
      try {
        await navigator.clipboard.writeText(text)
        this.runtimeError.healthMessage = '错误日志已复制。'
      } catch (e) {
        console.error('[copy runtime logs failed]', e, text)
        this.runtimeError.healthMessage = '复制失败，请打开控制台执行 window.__SEAF_GET_RUNTIME_ERRORS__() 查看。'
      }
    }
  }
}
</script>

<style>
html, body, #app {
  font-family: 'Helvetica Neue', 'Hiragino Sans GB', 'WenQuanYi Micro Hei', 'Microsoft Yahei', sans-serif;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 15px;
}

.runtime-error-mask {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.runtime-error-card {
  width: min(520px, calc(100vw - 32px));
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  background: #fff;
  text-align: center;
}

.runtime-error-card h2 {
  margin: 0 0 12px;
  color: #c0392b;
}

.runtime-error-card p {
  margin: 8px 0;
  color: #333;
}

.runtime-error-health {
  color: #666;
  font-size: 14px;
}

.runtime-error-detail {
  color: #666;
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  word-break: break-word;
}

.runtime-error-id {
  color: #1f6feb;
  font-weight: 700;
  font-family: Menlo, Monaco, Consolas, monospace;
}

.runtime-error-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
}

.runtime-error-actions button {
  border: 0;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  background: #1f6feb;
  color: #fff;
}
</style>
